import * as React from "react"
import cx from "classnames"

import * as styles from "./styles.module.scss"
import { FlowQuestionData, FlowQuestionId } from "types"

export interface SummaryAccordionItemProps {
  editHandler: (questionId: FlowQuestionId) => void
  questionsData: FlowQuestionData
  questionId: FlowQuestionId
  userAnswers: any
}

const SummaryAccordionItem: React.FC<SummaryAccordionItemProps> = ({
  editHandler,
  questionsData,
  questionId,
  userAnswers,
}) => {
  const triggerEdit = (e: React.MouseEvent, questionId: FlowQuestionId) => {
    // lose focus on button so document can listen for keypress
    ;(e.currentTarget as HTMLInputElement).blur()
    editHandler(questionId)
  }

  return (
    <li
      className={cx({
        [styles.item]: true,
        [styles.hasAnswer]: userAnswers[questionId],
      })}
      data-flow-key={questionId}
      key={`summary-item-${questionId}`}
    >
      <div className={styles.shadow}>
        <button
          className={styles.box}
          onClick={(e) => triggerEdit(e, questionId)}
        >
          <p className={styles.question}>{questionsData[questionId].title}</p>
          <h4 className={styles.answer}>
            <span className={styles.underline}>
              {userAnswers[questionId] && userAnswers[questionId].display}
            </span>
          </h4>
          <div className={styles.editWrap}>
            <span className={styles.edit}>Edit</span>
          </div>
        </button>
      </div>
    </li>
  )
}

export default SummaryAccordionItem
